import React from 'react';
export const RightSidebar = () => {
  return (
    <div className="fixed right-0 top-20 flex flex-col items-center space-y-4 p-2">
      {['📌', '⛶', '➕', '➖', '🔒'].map((icon, i) => (
        <button
          key={i}
          className="p-2 bg-gray-800/80 backdrop-blur rounded-full"
        >
          {icon}
        </button>
      ))}
    </div>
  );
};
